import { useEffect, useRef, type ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { t } from "../../lib/i18n";
import { useLocale } from "../../lib/useLocale";
import { SetupReturnBanner } from "../setup/SetupReturnBanner";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

import "./layout.css";

export function AppShell({ children }: { children: ReactNode }) {
  useLocale();
  const menu = useRef<HTMLDialogElement>(null);
  const location = useLocation();
  useEffect(() => {
    menu.current?.close();
  }, [location.key]);
  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 901px)");
    const closeOnDesktop = () => {
      if (desktop.matches) menu.current?.close();
    };
    desktop.addEventListener("change", closeOnDesktop);
    return () => desktop.removeEventListener("change", closeOnDesktop);
  }, []);

  return (
    <div className="app-shell">
      <div className="app-shell__desktop-nav">
        <Sidebar />
      </div>
      <dialog
        ref={menu}
        className="mobile-nav"
        aria-label={t("nav.menu")}
        onClick={(event) => {
          if (event.target === event.currentTarget) menu.current?.close();
        }}
      >
        <button
          type="button"
          className="btn btn--ghost mobile-nav__close"
          onClick={() => menu.current?.close()}
          aria-label={t("nav.closeMenu")}
        >
          ×
        </button>
        <Sidebar onNavigate={() => menu.current?.close()} />
      </dialog>
      <Topbar onOpenMenu={() => menu.current?.showModal()} />
      <main className="app-shell__main">
        <div className="app-shell__content">
          <SetupReturnBanner />
          {children}
        </div>
      </main>
    </div>
  );
}
